<template>
    <form @submit.prevent="submit">
        <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-white">
                Nome do atendente
            </label>
            <input
                v-model="form.name"
                type="text"
                class="w-full px-3 py-2 text-black bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Ex.: Maria Silva"
                required
            />
        </div>

        <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-white">
                Telefone do WhatsApp
            </label>
            <input
                v-model="form.phone"
                type="text"
                class="w-full px-3 py-2 text-black bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Ex.: 5519996140114"
                required
            />
            <p class="mt-1 text-xs text-gray-400">
                Com DDI e DDD, somente números. Número brasileiro digitado sem o 55 recebe o DDI automaticamente.
            </p>
        </div>

        <div class="mb-4">
            <form-toggle
                v-model="form.is_active"
                label="Recebendo leads"
            />
        </div>

        <div class="flex justify-end space-x-2">
            <submit-button
                :loading="loading"
                class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md"
            >
                {{ attendant ? 'Atualizar' : 'Salvar' }}
            </submit-button>
        </div>
    </form>
</template>

<script>
import { useToast } from "vue-toastification";
import SubmitButton from "../forms/SubmitButton.vue";
import FormToggle from "../forms/FormToggle.vue";

export default {
    props: { attendant: { type: Object, default: null } },
    components: { SubmitButton, FormToggle },
    emits: ["fetch"],
    data() {
        return {
            loading: false,
            form: {
                name: "",
                phone: "",
                is_active: true,
            },
        };
    },
    setup() {
        const toast = useToast();
        return { toast };
    },
    mounted() {
        if (this.attendant) {
            this.form = {
                name: this.attendant.name,
                phone: this.attendant.phone,
                is_active: this.attendant.is_active,
            };
        }
    },

    methods: {
        submit() {
            if (!this.form.name.trim() || !this.form.phone.trim()) {
                this.toast.error("Preencha o nome e o telefone do atendente.");
                return;
            }

            this.loading = true;

            const promise = this.attendant
                ? axios.put(`/api/lead-routing/attendants/${this.attendant.id}`, this.form)
                : axios.post("/api/lead-routing/attendants", this.form);

            promise
                .then(() => {
                    this.$emit("fetch");
                    this.toast.success("Atendente salvo com sucesso!");
                })
                .catch((error) => {
                    const message = error.response?.data?.message || "Não foi possível concluir essa solicitação.";
                    this.toast.error(message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
